// @flow

import React from 'react';
import { withTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';

import { logGAEvent } from '../util/log-ga';
import { addBodyModalClass, removeBodyModalClass } from '../util/modal';
import { TextField } from '@material-ui/core';
import { validateEmail } from '../util/validate-email';
import FormHelperText from '@material-ui/core/FormHelperText';

type Props = {
  applyCallback: Function,
  t: (value: string, opts?: any) => string,
};

type State = {
  modalOpen: boolean;
  firstName: ?string,
  lastName: ?string,
  email: ?string,
  errors: Object,
}

const formEntryStyle = {
  paddingLeft: '20px',
  paddingRight: '20px',
  maxWidth: '400px',
  width: '100%',
  marginBottom: '10px',
};

const formStyle = {
  height: '500px',
  maxWidth: '400px',
};

class Transition extends React.PureComponent<Props>{
  render() {
    // $flow-disable-next-line
    return <Slide direction="up" {...this.props} />;
  }
}

class ManualApply extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      modalOpen: false,
      firstName: null,
      lastName: null,
      email: null,
      errors: {},
    };
  }

  onChange = (field: string) => (event: SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({
      [field]: event.currentTarget.value,
    });
  };

  apply = () => {
    const { t } = this.props;
    const errors = {};
    if (!this.state.firstName || this.state.firstName.trim().length === 0) {
      errors['firstName'] = t('required');
    }

    if (!this.state.lastName || this.state.lastName.trim().length === 0) {
      errors['lastName'] = t('required');
    }

    if (!this.state.email || this.state.email.trim().length === 0) {
      errors['email'] = t('required');
    }

    const emailError = validateEmail(this.state.email);
    if (emailError) {
      errors['email'] = emailError;
    }

    this.setState({
      errors,
    });
    if (Object.keys(errors).length > 0) {
      return;
    }

    const valuesToSubmit = Object.assign({}, {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
    });
    Object.keys(valuesToSubmit).forEach((key) => {
      valuesToSubmit[key] = valuesToSubmit[key].trim();
    });
    valuesToSubmit.type = 'manual';
    this.props.applyCallback(valuesToSubmit);
    this.handleClose();
  };

  openApplyDialog = () => {
    addBodyModalClass();
    this.setState({
      modalOpen: true,
    });
    logGAEvent('Application', 'Clicked Manual Apply');
  }

  handleClose = () => {
    removeBodyModalClass();
    this.setState({
      modalOpen: false,
    });
  }

  render() {
    const { t } = this.props;
    return (
      <div style={{ textAlign: 'center' }}>
        <Button variant="outlined" color="default" style={{ paddingTop: '10.5px', paddingBottom: '10.5px' }} onClick={this.openApplyDialog}>
          {t('applyManually')}
        </Button>
        <Dialog
          open={this.state.modalOpen}
          onClose={this.handleClose}
          fullScreen
          TransitionComponent={Transition}
        >
          <div style={formStyle}>
            <DialogTitle id="form-dialog-title">{t('basicInformation')}</DialogTitle>
            <DialogContent>

              <FormGroup>
                <FormControl style={formEntryStyle}>
                  <TextField
                    name="firstName"
                    label={t('firstName')}
                    margin="dense"
                    onChange={this.onChange('firstName')}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    error={this.state.errors.firstName !== undefined}
                  />
                  {this.state.errors.firstName &&
                  <FormHelperText error>
                    {this.state.errors.firstName}
                  </FormHelperText>
                  }
                </FormControl>
                <FormControl style={formEntryStyle}>
                  <TextField
                    name="lastName"
                    label={t('lastName')}
                    margin="dense"
                    onChange={this.onChange('lastName')}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    error={this.state.errors.lastName !== undefined}
                  />
                  {this.state.errors.lastName &&
                  <FormHelperText error>
                    {this.state.errors.lastName}
                  </FormHelperText>
                  }
                </FormControl>
                <FormControl style={formEntryStyle}>
                  <TextField
                    name="email"
                    label={t('email')}
                    margin="dense"
                    onChange={this.onChange('email')}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    error={this.state.errors.email !== undefined}
                  />
                  {this.state.errors.email &&
                  <FormHelperText error>
                    {this.state.errors.email}
                  </FormHelperText>
                  }
                </FormControl>
              </FormGroup>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="default">
                {t('cancel')}
              </Button>
              <Button variant="contained" color="primary" onClick={this.apply}>
                {t('apply')}
              </Button>
            </DialogActions>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default withTranslation()(ManualApply);
